const appConfig = { data: {} };

export default appConfig;
